import { useLocation, useParams } from 'react-router';
import { BackButton, Box, Column, FloatingContainer, Row, Screen, Tab, TabList, TabPanel, Tabs, Text } from '~/commonComponents';
import { DashboardJobsType } from '~/domain/DashboardJobs';
import { Colors } from '~/themes/colors';
import { OpenTab, PendingTab, ScheduledTab } from './components';
import { useShiftList } from './hooks';
import { TJobListPageRoutes, TJobListPageRoutesLocationState } from './Types';

export const JobList = () => {
  const params = useParams<TJobListPageRoutes>();
  const location = useLocation() as Partial<{ state: Partial<TJobListPageRoutesLocationState> }>;

  const { activeTab, dashboardInfo, onChangeTab } = useShiftList({
    type: (location.state?.type || params.type) as DashboardJobsType,
  });

  const countOpen = dashboardInfo?.openCount || 0;
  const countPending = dashboardInfo?.pendingCount || 0;
  const countScheduled = dashboardInfo?.filledCount || 0;

  return (
    <Screen>
      <FloatingContainer borderRadius={0} paddingBlock={48} paddingInline={16} height="100%">
        <Row position="relative" alignItems="center" justifyContent="center">
          <Box position="absolute" left={0}>
            <BackButton />
          </Box>
          <Text bold fontSize={32} textAlign="center">
            Shifts & Interviews
          </Text>
        </Row>
        <Row
          alignItems="center"
          justifyContent="space-between"
          marginBottom={36}
          marginInline={38}
          marginTop={24}
        >
          <Tabs initialTab={activeTab} tabListStyle={{ marginBottom: 0 }} onChangeTab={onChangeTab}>
            <TabList>
              <Tab
                dataCy="open-shifts-tab"
                title="Open"
                totalCount={countOpen > 99 ? '99+' : countOpen}
              />
              <Tab
                dataCy="action-needed-tab"
                title="Action Needed"
                totalCount={countPending > 99 ? '99+' : countPending}
                totalCountStyle={
                  countPending > 0
                    ? {
                        backgroundColor: activeTab === 1 ? Colors.error_500 : Colors.error_100,
                      }
                    : {}
                }
                totalCountTextStyle={
                  countPending > 0
                    ? {
                        color: activeTab === 1 ? Colors.white : Colors.error_500,
                      }
                    : {}
                }
              />
              <Tab
                dataCy="scheduled-shifts-tab"
                title="Scheduled"
                totalCount={countScheduled > 99 ? '99+' : countScheduled}
              />
            </TabList>
            <TabPanel>
              <Box />
              <Box />
              <Box />
            </TabPanel>
          </Tabs>
          {/* TODO: Implemented on ARF-1115 */}
          {/* <Row alignItems="center" gap={10}>
            <Text bold fontSize={18}>
              Filter by:
            </Text>
            <Box width={212}>
              <InputSelect
                isSelectVisible={false}
                options={FilterOptions}
                value="all"
                setValue={() => {}}
              />
            </Box>
          </Row> */}
        </Row>
        <Column marginInline={36}>
          {activeTab === 0 && <OpenTab />}
          {activeTab === 1 && <PendingTab />}
          {activeTab === 2 && <ScheduledTab />}
        </Column>
      </FloatingContainer>
    </Screen>
  );
};
